module.exports = __webpack_public_path__ + "img/Darbi.c32e7192.jpg";